const DeleteAccount = () => {
  return (
    <div className="min-h-screen bg-white py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg border-0">
          <div className="p-6 text-center">
            <h1 className="mb-4 text-2xl font-bold">How to Delete Your Account (Tutor Match AE App)</h1>
            <p className="text-gray-500">Follow these steps to remove your account and associated activities.</p>

            <hr className="border-gray-200" />

            <div className="step-section my-4">
              <h5 className="mb-3 text-lg font-semibold">Step 1: Open the Tutor Match AE App</h5>
              <p>Launch the Tutor Match AE App on your device and tap on the Settings icon in the bottom-right corner.</p>
              <img
                src={`${process.env.PUBLIC_URL}/assets/TMAE-1.png`}
                alt="Step 1"
                className="max-w-full h-auto rounded shadow block mx-auto"
                style={{ width: '250px' }}
              />
            </div>

            <hr className="border-gray-200" />

            <div className="step-section my-4">
              <h5 className="mb-3 text-lg font-semibold">Step 2: Navigate to Account Settings</h5>
              <p>Scroll down in the account settings.</p>
              <img
                src={`${process.env.PUBLIC_URL}/assets/TMAE-2.png`}
                alt="Step 2"
                className="max-w-full h-auto rounded shadow block mx-auto"
                style={{ width: '250px' }}
              />
            </div>

            <div className="step-section my-4">
              <h5 className="mb-3 text-lg font-semibold">Step 3: Navigate to Account Deletion</h5>
              <p>Locate the <b>"Delete Account"</b> option.</p>
              <img
                src={`${process.env.PUBLIC_URL}/assets/TMAE-3.png`}
                alt="Step 2"
                className="max-w-full h-auto rounded shadow block mx-auto"
                style={{ width: '250px' }}
              />
            </div>

            <hr className="border-gray-200" />

            <div className="step-section my-4">
              <h5 className="mb-3 text-lg font-semibold">Step 4: Confirm Account Deletion</h5>
              <p>A confirmation modal will appear. Select valid reason and click <b>"Submit"</b> to proceed and permanently delete your account.</p>
              <img
                src={`${process.env.PUBLIC_URL}/assets/TMAE-4.png`}
                alt="Step 4"
                className="max-w-full h-auto rounded shadow block mx-auto"
                style={{ width: '250px' }}
              />
            </div>

            <hr className="border-gray-200" />

            <div className="final-message mt-4">
              <h6 className="text-red-600 font-semibold">⚠ Note:</h6>
              <p className="text-gray-500">
                Once deleted, your account and all associated data cannot be recovered.
                Please ensure you have backed up any necessary information before proceeding.
              </p>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
